// Libraries
import {
  NgModule,
  ModuleWithProviders
} from '@angular/core';
import {
  HTTP_INTERCEPTORS
} from '@angular/common/http';

// Services
import { PollingService } from './polling.service';

// Components
import { BasePollingComponent } from './base-polling.component';

const COMPONENTS: any = [
  BasePollingComponent
];

/**
 * Define pooling module
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@NgModule({
  declarations: [
    COMPONENTS
  ],
  imports: [
  ]
})
export class PollingModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: PollingModule,
      providers: [
        PollingService
      ]
    };
  }
}
